import { TRenderable } from "source/app/presentation/Shared/SharedTypes";
import { IQuickJournalEntry } from "../Data/QuickJournalTypes";

const quickJournalPaperCenterOffsetInPixels = 5;

export function GetQuickJournalLeftPosition(): string {
    return "calc(50vw - 88px)";
}

export function GetQuickJournalPaperCenterOffsetInPixels(): number {
    return quickJournalPaperCenterOffsetInPixels;
}

export function GetQuickJournalPaperCenterCssPosition(): string {
    return `calc(50% + ${quickJournalPaperCenterOffsetInPixels}px)`;
}

export function GetRecentEntryOpacity(index: number, numItems: number): number {
    if (numItems <= 1) {
        return 1;
    }

    const progressToNewest = index / (numItems - 1);
    return 0.06 + Math.pow(progressToNewest, 2.1) * 0.94;
}

export function GetJournalEntryRenderKey(
    entry: IQuickJournalEntry | TRenderable | null,
    index: number,
    useStableEntryIdentity = false
): string {
    if (!entry || typeof entry !== "object" || !("createdAt" in entry)) {
        return `quick-journal-filler-${index}`;
    }

    const entryIdentity = `${entry.createdAt}_${entry.text}`;
    return useStableEntryIdentity ? entryIdentity : `${entryIdentity}_${index}`;
}

export function GetVisualViewportScale(): number {
    if (typeof window === "undefined") {
        return 1;
    }

    const scale = window.visualViewport?.scale ?? 1;

    if (!Number.isFinite(scale) || scale <= 0) {
        return 1;
    }

    return scale;
}

export function GetWindowScrollPosition() {
    if (typeof window === "undefined") {
        return { x: 0, y: 0 };
    }

    return {
        x: window.scrollX,
        y: window.scrollY,
    };
}

export function RestoreWindowScrollPosition(position: { x: number; y: number }) {
    window.scrollTo(position.x, position.y);
}

export function IsIosDevice(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    const platform = navigator.platform || "";
    const userAgent = navigator.userAgent || "";

    return (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
}
